import AppBar from '@material-ui/core/AppBar';
import { Button } from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Gravatar from 'ui/Gravatar';
import Grow from '@material-ui/core/Grow';
import HelpIcon from '@material-ui/icons/Help';
import IconButton from '@material-ui/core/IconButton';
import { Link } from 'react-router-dom';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import React from 'react';
import Toolbar from '@material-ui/core/Toolbar';
// import NotificationsIcon from '@material-ui/icons/Notifications';
import Typography from '@material-ui/core/Typography';
import { WebAppSSO } from './WebAppSSO';
import classNames from 'classnames';
import { flowRight } from 'lodash/fp';
import { withAppContext } from '../AppContext';
import { withStyles } from '@material-ui/core/styles';

const drawerWidth = 240;

const styles = theme => ({
    root: {
        display: 'flex',
    },
    appBar: {
        backgroundColor: '#00ae92 !important',
        color: '#fff !important',
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 20,
    },
    menuButtonHidden: {
        display: 'none',
    },
    breadcrumbs: {
        flex: 1,
        display: 'flex',
    },
    separator: {
        userSelect: 'none',
        paddingLeft: theme.spacing(),
        paddingRight: theme.spacing(),
    },

    appBarSpacer: theme.mixins.toolbar,

    toolbar: {
        paddingLeft: theme.spacing(),
        paddingRight: 0,
    },

    notificationToolbar: {
        paddingLeft: theme.spacing(),
        paddingRight: 0,
        background: '#a7ffeb',
        color: '#00bfa5',
    },

    logout: {
        textTransform: 'none',
    },

    link: {
        textDecoration: 'none',
    },
});

class AppBarHeader extends React.PureComponent {
    state = {
        anchorEl: null,
    };

    handleMenu = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    renderBreadcrumbs(breadcrumbs, classes) {
        const link = (key, name, path) => (
            <Typography
                key={key}
                to={path}
                component={Link}
                variant="h6"
                color="inherit"
                noWrap
                className={classes.link}
            >
                {name}
            </Typography>
        );
        const text = (key, name) => (
            <Typography
                key={key}
                component="h1"
                variant="h6"
                color="inherit"
                noWrap
            >
                {name}
            </Typography>
        );

        const separator = key => (
            <Typography
                key={`sep-${key}`}
                component="h1"
                variant="h6"
                color="inherit"
                className={classes.separator}
                noWrap
            ></Typography>
        );

        return breadcrumbs.reduce((acc, current, index) => {
            if (index > 0) {
                acc.push(separator(index));
            }
            if (current.path) {
                acc.push(link(index, current.name, current.path));
            } else {
                acc.push(text(index, current));
            }

            return acc;
        }, []);
    }

    render() {
        const {
            app,
            classes,
            user,
            breadcrumbs = [],
            notification,
        } = this.props;
        const { anchorEl } = this.state;
        const open = Boolean(anchorEl);

        return (
            <AppBar
                position="fixed"
                className={classNames(
                    classes.appBar,
                    this.props.open && classes.appBarShift
                )}
            >
                {notification && (
                    <Toolbar className={classes.notificationToolbar}>
                        {notification}
                    </Toolbar>
                )}
                <Toolbar className={classes.toolbar}>
                    <IconButton
                        color="inherit"
                        aria-label="Open drawer"
                        onClick={() => this.props.openClickDrawer()}
                        className={classes.menuButton}
                    >
                        <MenuIcon />
                    </IconButton>
                    <div className={classes.breadcrumbs}>
                        {this.renderBreadcrumbs(breadcrumbs, classes)}
                    </div>

                    <IconButton
                        component="a"
                        color="inherit"
                        href={app.settings.brand.partner_portal_docs_url}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <HelpIcon />
                    </IconButton>

                    {/*
                        <IconButton color="inherit">
                            <NotificationsIcon />
                        </IconButton>
                    */}
                    <Button
                        color="inherit"
                        variant="text"
                        ref={node => {
                            this.anchorEl = node;
                        }}
                        onClick={this.handleMenu}
                        classes={{ root: classes.logout }}
                    >
                        <span style={{ paddingRight: '10px' }}>
                            {user.email}
                        </span>
                        <Gravatar email={user.email} color={user.color} />
                    </Button>
                    <Popper
                        open={open}
                        anchorEl={this.anchorEl}
                        transition
                        disablePortal
                    >
                        {({ TransitionProps, placement }) => (
                            <Grow
                                {...TransitionProps}
                                id="menu-list-grow"
                                style={{
                                    transformOrigin:
                                        placement === 'bottom'
                                            ? 'center top'
                                            : 'center bottom',
                                }}
                            >
                                <Paper>
                                    <ClickAwayListener
                                        onClickAway={this.handleClose}
                                    >
                                        <MenuList>
                                            <MenuItem
                                                component={Link}
                                                to="/account/profile/profile"
                                                onClick={this.handleClose}
                                                style={{
                                                    width: '100%',
                                                }}
                                            >
                                                My Profile
                                            </MenuItem>
                                            <WebAppSSO
                                                onClose={this.handleClose}
                                            />
                                            <MenuItem
                                                style={{
                                                    width: '100%',
                                                }}
                                            >
                                                <a
                                                    href="/auth/logout"
                                                    style={{
                                                        textDecoration: 'none',
                                                        color: 'inherit',
                                                    }}
                                                >
                                                    Logout
                                                </a>
                                            </MenuItem>
                                        </MenuList>
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                </Toolbar>
            </AppBar>
        );
    }
}
export default flowRight(withStyles(styles), withAppContext)(AppBarHeader);
